module.exports = __webpack_public_path__ + "img/POWER_EQU.305c8764.jpg";